module.exports = __webpack_public_path__ + "static/media/yunhaochefu11.f43bb306.png";